import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

const CONTROL_PANEL_BASE_URL = 'https://complete.channeladvisor.com';
const ACCOUNT_ID = '12003175';

function SaleData(props) {
  const { t, reference, customerEmail } = props;
  const encodedReference = encodeURIComponent(reference);
  const encodedEmail = customerEmail !== null ? encodeURIComponent(customerEmail) : null;
  const encodedSubject = encodeURIComponent(`Question about order ${reference}`);

  const linkStyle = {
    color: '#ffd166',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.35rem',
    marginBottom: '0.75rem',
    fontWeight: 500,
    textDecoration: 'none',
  };

  const iconStyle = {
    fontSize: '1.15rem',
  };

  const jsx = (
    <div>
      <a
        href={`${CONTROL_PANEL_BASE_URL}/Orders/OrderDetailV2.mvc?apid=${ACCOUNT_ID}&invoiceId=${encodedReference}`}
        target="_blank"
        rel="noreferrer"
        style={linkStyle}
      >
        {t('View on ChannelAdvisor')}
        <span className="bx bx-window-open" style={iconStyle} />
      </a>

      <div />

      {customerEmail !== null && customerEmail !== '' && (
        <a
          href={`mailto:${encodedEmail}?subject=${encodedSubject}`}
          style={linkStyle}
        >
          {t('Email Customer')}
          <span className="bx bx-mail-send" style={iconStyle} />
        </a>
      )}

      {(customerEmail === null || customerEmail === '') && (
        <p className="text-muted mb-0">{t('Customer email unavailable')}</p>
      )}
    </div>
  );

  return jsx;
}

SaleData.defaultProps = {
  t: (w) => w,
  customerEmail: null,
};

SaleData.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  reference: PropTypes.string.isRequired,
  customerEmail: PropTypes.string,
};

export default connect(() => ({

}), {})(withTranslation()(SaleData));
